/**
 * Copied from input, this was necessary for IE support.
 * Everything dealing with calculating height can be replaced with height 'auto' when IE11 support is dropped.
 */
var multilinePadding = {
  touch: {
    top: 12,
    bottom: 11
  },
  low: {
    top: 10,
    bottom: 8
  },
  medium: {
    top: 6,
    bottom: 6
  },
  high: {
    top: 3,
    bottom: 3
  }
};
var multilineFieldPadding = {
  touch: {
    top: 12,
    bottom: 8
  },
  low: {
    top: 9,
    bottom: 7
  },
  medium: {
    top: 6,
    bottom: 6
  },
  high: {
    top: 3,
    bottom: 2
  }
};
export var style = function style(_ref) {
  var _ref$toolkit$palette = _ref.toolkit.palette,
      grey200 = _ref$toolkit$palette.grey200,
      grey70 = _ref$toolkit$palette.grey70,
      type = _ref$toolkit$palette.type;

  var createDensityStyle = function createDensityStyle(density) {
    return {
      '&$field&$multiline $mask': {
        height: "calc(100% - ".concat(multilineFieldPadding[density].top, "px - ").concat(multilineFieldPadding[density].bottom, "px)")
      },
      '&$multiline $input': {
        height: "calc(100% - ".concat(multilinePadding[density].top, "px - ").concat(multilinePadding[density].bottom, "px)")
      }
    };
  };

  return {
    inputWrapper: {
      position: 'relative',
      width: '100%',
      display: 'inline-flex'
    },
    mask: {
      position: 'absolute',
      color: type === 'light' ? grey200 : grey70,
      pointerEvents: 'none',
      display: 'flex',
      'align-items': 'center',
      top: '0px',
      left: '0px',
      whiteSpace: 'pre',
      '& i': {
        color: 'transparent',
        opacity: 0,
        visibility: 'hidden',
        font: 'inherit'
      }
    },
    // Input styles copied
    root: {},
    input: {},
    endAdornment: {},
    startAdornment: {},
    field: {},
    multiline: {},
    inputMultiline: {},
    leftTextAlign: {},
    rightTextAlign: {
      '& $mask': {
        justifyContent: 'flex-end'
      }
    },
    suffixContainer: {},
    prefixContainer: {},
    focused: {},
    readOnly: {},
    disabled: {},
    touchDensity: createDensityStyle('touch'),
    lowDensity: createDensityStyle('low'),
    mediumDensity: createDensityStyle('medium'),
    highDensity: createDensityStyle('high')
  };
};